module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.ttf?6ecea4826b87fafb97be19edfa667a31";